import { render, staticRenderFns } from "./Advantage.vue?vue&type=template&id=3c2c84e2&scoped=true"
import script from "./Advantage.vue?vue&type=script&lang=js"
export * from "./Advantage.vue?vue&type=script&lang=js"
import style0 from "./Advantage.vue?vue&type=style&index=0&id=3c2c84e2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2c84e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c2c84e2')) {
      api.createRecord('3c2c84e2', component.options)
    } else {
      api.reload('3c2c84e2', component.options)
    }
    module.hot.accept("./Advantage.vue?vue&type=template&id=3c2c84e2&scoped=true", function () {
      api.rerender('3c2c84e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/self-select-stock/components/Advantage.vue"
export default component.exports